export default {
  tranches: [5000, 10000, 100000, 500000, 1000000],
  cremant: [7.5, 6.5, 5.5, 5, 4, 3],
  champagne: [12, 11, 10, 9, 8, 7],
};
